import React, { useEffect, useState } from "react";
import { getPrefixes, rolsResource, usersResource } from "../../helpers/configRoutes/backend_helper";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/form/CustomInput";
import CustomSelect from "../../components/form/CustomSelect";
import { showFormErrors } from "../../helpers/showFormErrors";
import FileInput from "../../components/form/FileInput";
import ModulesPermissions from "./ModulesPermissions";
import CustomButton from "../../components/form/CustomButton";
import { validatePhones } from "../../helpers/forms/Validation";

const AddUpdTeam = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [prefixes, setPrefixes] = useState([]);
    const [rols, setRols] = useState([]);
    const [modal, setModal] = useState({
        show: false,
        loading: true,
        textLoad: "Saving",
        title: "Select Permissions",
        user: true,
    });
    const [loading, setLoading] = useState(false);

    // Formik
    const validation = useFormik({
        initialValues: {
            id: null,
            active: true,
            email: "",
            first_name: "",
            last_name: "",
            role_id: "",
            phone: "",
            prefix_id: "",
            company_id: "",
            profile_id: 2,
            imageProfile: "",
            modelsPermissions: [],
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Invalid email").required("Email is required"),
            first_name: Yup.string().required("First name is required"),
            last_name: Yup.string().required("Last name is required"),
            role_id: Yup.string().required("Role is required"),
            phone: validatePhones(true),
            prefix_id: Yup.string().required("Prefix is required"),
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);
            const response = await usersResource(
                values.id ? "put" : "post",
                values,
                values.id
            );
            if (response.status) {
                navigate("/team");
            } else {
                setErrors(response.errors || {});
            }
            setLoading(false);
        },
    });

    // Cargar usuario si es edición
    useEffect(() => {
        const getUser = async () => {
            const response = await usersResource("show", {}, id);
            if (response.status && response.user) {
                Object.keys(response.user).forEach((field) => {
                    validation.setFieldValue(field, response.user[field], false);
                });
            }
        };
        if (id) getUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // Cargar prefijos
    useEffect(() => {
        const getPrefixesCatalog = async () => {
            const response = await getPrefixes();
            if (response.status) {
                setPrefixes(response.prefixes || []);
            }

            const responseRols = await rolsResource('get', { params: { select: true } });
            if (responseRols.status) {
                setRols(responseRols.rols || []);
            }
        };
        getPrefixesCatalog();
    }, []);

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            {id ? "Update member" : "Add new member"}
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            {id
                                ? "Edit user information and access permissions."
                                : "Create a new user and assign their role and permissions."}
                        </p>
                    </div>
                </div>

                {/* Form card */}
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        showFormErrors(validation);
                        return false;
                    }}
                >
                    <div
                        className="
        max-w-auto mx-auto
        bg-cs-bg
        rounded-3xl
        border border-cs-border
        shadow-sm
        px-6 py-6 md:px-8 md:py-8
      "
                    >
                        {/* Avatar */}
                        <div className="flex justify-center mb-6">
                            <div className="flex flex-col items-center gap-2">
                                <div className="relative">
                                    <img
                                        className="
                w-24 h-24 md:w-28 md:h-28
                rounded-full object-cover
                border-2 border-cs-primary-soft
              "
                                        src={
                                            validation.values.imageProfile ||
                                            "/images/usrAnonimo.png"
                                        }
                                        alt="Profile"
                                    />
                                </div>
                                <FileInput
                                    format="img"
                                    name="imageProfile"
                                    validation={validation}
                                />
                                <p className="text-[10px] text-cs-muted">
                                    Recommended: square image, clear face, max 2MB.
                                </p>
                            </div>
                        </div>

                        {/* Fields */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <CustomInput
                                label="First name"
                                type="text"
                                name="first_name"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={validation.errors.first_name}
                                value={validation.values.first_name}
                                handleChange={validation.handleChange}
                            />

                            <CustomInput
                                label="Last name"
                                type="text"
                                name="last_name"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={validation.errors.last_name}
                                value={validation.values.last_name}
                                handleChange={validation.handleChange}
                            />

                            <CustomInput
                                label="Email"
                                type="email"
                                name="email"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={validation.errors.email}
                                value={validation.values.email}
                                handleChange={validation.handleChange}
                            />

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <CustomSelect
                                    label="Phone prefix"
                                    options={prefixes}
                                    name="prefix_id"
                                    labelClassName="text-xs font-medium text-cs-dark"
                                    error={validation.errors.prefix_id}
                                    value={validation.values.prefix_id}
                                    handleChange={validation.handleChange}
                                />

                                <CustomInput
                                    label="Phone number"
                                    type="text"
                                    name="phone"
                                    labelClassName="text-xs font-medium text-cs-dark"
                                    error={validation.errors.phone}
                                    value={validation.values.phone}
                                    handleChange={validation.handleChange}
                                />
                            </div>

                            <CustomSelect
                                label="Role"
                                options={rols}
                                name="role_id"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={validation.errors.role_id}
                                value={validation.values.role_id}
                                handleChange={validation.handleChange}
                            />

                            <CustomSelect
                                label="Status"
                                options={[
                                    { id: 1, name: "Active" },
                                    { id: 0, name: "Suspended" },
                                ]}
                                name="active"
                                disabled={
                                    validation.values.id
                                        ? !validation.values?.can?.disable
                                        : false
                                }
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={validation.errors.active}
                                value={validation.values.active}
                                handleChange={validation.handleChange}
                            />
                        </div>

                        {/* Actions */}
                        <div className="mt-8 flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={() => navigate("/team")}
                                className="
            px-4 py-2.5 rounded-xl
            text-xs md:text-sm
            border border-cs-border
            text-cs-muted
            hover:bg-cs-bg-alt
            transition-colors
          "
                            >
                                Cancel
                            </button>

                            <CustomButton
                                loading={loading}
                                textLoad="Processing..."
                                type="submit"
                                className="
            px-6 py-2.5 rounded-xl
            bg-cs-primary hover:bg-cs-primary-hover
            text-white text-xs md:text-sm font-medium
            shadow-md hover:shadow-lg
            transition-all
          "
                            >
                                {id ? "Save changes" : "Create user"}
                            </CustomButton>
                        </div>
                    </div>
                </form>
            </div>


            {modal.show && (
                <ModulesPermissions
                    modal={modal}
                    setModal={setModal}
                    validation={validation}
                />
            )}
        </>
    );
};

export default AddUpdTeam;
